<template>
  <div
    class="site"
    :class="{ debug: debug }"
    data-test-id="signage-site"
    @click="$router.push('/')"
  >
    <warning-message
      v-if="!site.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <div v-else-if="site">
      <warning-message
        v-if="movies.length == 0"
      >
        {{ $t('showing.noShowingsToday') }}
      </warning-message>
      <!-- We have a showtimes-->
      <div
        class="fixed-full"
        :class="{ 'row': $isLandscapeView() }"
        :style="{
          top: marginVertical + 'px ',
          bottom: marginVertical + 'px ',
          left: +marginHorizontal + 'px',
          right: +marginHorizontal + 'px'
        }"
      >
        <div
          class="column"
          :class="{ 'col-7': $isLandscapeView() }"
        >
          <div
            v-if="showLogo"
            class="col-auto row justify-between"
          >
            <div class="col text-left">
              <img
                style="height: 5vh; padding: 1vh;"
                :style="{ height: $isLandscapeView() ? '4vw' : '5vh' }"
                :src="site.lightLogoImageUrl"
              >
            </div>

            <div
              class="col-auto row"
              style="padding: 1vh;"
            >
              <div
                class="text-right text-uppercase text-bold"
                style="font-size: 2.4vh;"
              >
                {{ site.siteTime.format("h:mm a") }}
              </div>
            </div>
          </div>

          <div
            class="col"
            :class="{ 'row': $isLandscapeView() }"
          >
            <div
              class="wrapper full-width"
            >
              <swiper
                :modules="[Autoplay]"
                :autoplay="signageAutoplay"
                :direction="'vertical'"
                :height="showLogo ? windowHeight * 0.92 : windowHeight"
                :slides-per-view="moviesPerPage"
                :slides-per-group="pageMode ? moviesPerPage : 1"
                :space-between="10"
                :loop="hasMultiSlides"
                preload-images
                class="swiper"
              >
                <swiper-slide
                  v-for="(showings, movieId) in movies"
                  :key="movieId"
                  class="row movie-container"
                  :style="{ 'border-bottom': showingsHidePoster ? '0.2vw dotted rgba(255, 255, 255, 0.2)' : undefined }"
                >
                  <img
                    v-if="!showingsHidePoster"
                    style="max-height: 100%; object-fit: contain;"
                    :src="showings[0].movie.posterImageUrl"
                    class="q-pa-md"
                    :class=" $isLandscapeView() ? 'col-auto ' : moviesPerPage > 4 ? 'col-2' : 'col-3'"
                  >

                  <div
                    class="col column self-start"
                    style="padding: 2vh;"
                  >
                    <div
                      class="row justify-end items-center text-bold"
                      style="line-height: 1.2;"
                      :style="{
                        'font-size': $isLandscapeView() ? '2vw' : '2.6vh',
                        'margin-bottom': $isLandscapeView() ? '1vw' : '1vh'
                      }"
                    >
                      <span class="col text-left">
                        {{ showings[0].movie.name }}
                      </span>
                      <rated
                        v-if="showings[0].movie.rating"
                        :rated="showings[0].movie.rating"
                        :rating-reason="showings[0].movie.ratingReason"
                        is-font-size-responsive
                        :font-size="$isLandscapeView() ? 1.2 : 2.2"
                        :no-margin="false"
                        class="text-bold col-auto no-border-radius"
                        :outline="false"
                        color="white"
                        text-color="dark"
                        :highlight-r-rated="highlightRRated"
                        :disable-official-symbol="disableOfficialSymbol"
                      />
                    </div>
                    <div class="row justify-start items-center">
                      <q-chip
                        v-for="showing in showings"
                        :key="showing.id"
                        class="text-uppercase"
                        :outline="!showing.current"
                        :color="showing.current ? 'grey-4' : showing.past ? '' : 'white'"
                        :text-color="showing.current || showing.past ? '' : 'white'"
                        dense
                        square
                        style="padding: 0.5vh 1vh; margin-right: 1vh; margin-bottom: 1vh;"
                        :style="styleForShowing(showing)"
                      >
                        <div class="row full-width justify-center items-center self-center text-center text-bold">
                          {{ showing.siteTime.format("h:mm a") }}
                          <showing-badges
                            v-if="displayShowingBadges"
                            :showing="showing"
                            :color="showing.current ? site.primaryColor : 'white'"
                          />
                        </div>
                      </q-chip>
                      <q-chip
                        v-for="i in $_.range(maxShowings - showings.length)"
                        :key="i"
                        class="text-uppercase"
                        outline
                        dense
                        square
                        style="font-size:2vw; border-width: 0.05vw; padding: 0.2vw 0.9vh;color: #00000000"
                      >
                        <div class="row full-width justify-center text-center text-bold">
                          none
                        </div>
                      </q-chip>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div
          v-if="$isLandscapeView()"
          class="col-5 background-pattern"
        >
          <swiper
            :modules="[Autoplay, EffectFade]"
            :autoplay="autoplay"
            :slides-per-view="1"
            :effect="'fade'"
            loop
            class="swiper q-mx-auto"
          >
            <swiper-slide
              v-for="(showings, movieId) in movies"
              :key="movieId"
            >
              <img
                style="height: 100vh; width: auto; object-fit: cover;"
                :src="showings[0].movie.posterImageUrl"
              >
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      A network error occurred
    </warning-message>
    <warning-message
      v-else
    >
      {{ `Unknown Site - ${$route.params.id}` }}
    </warning-message>
  </div>
</template>

<script>
import SwiperModulesMixin from 'src/modules/consumer/components/mixins/SwiperModulesMixin'
import Rated from 'src/modules/consumer/components/Rated'
import ShowingBadges from 'src/modules/signage/components/ShowingBadges'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'

export default {
  name: 'ShowingsList',
  components: {
    Rated,
    WarningMessage,
    ShowingBadges
  },
  mixins: [ShowingsSignageConfigurationMixin, SwiperModulesMixin],
  models: {
    site: {
      fields: ['id', 'name', 'primaryColor', 'lightLogoImage', 'migratedTo'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default'
      },
      variables () {
        return {
          id: this.siteId
        }
      },
      immediate: true
    }
  },
  props: {
    overrideSiteId: {
      type: Number,
      required: false,
      default: null
    },
    overrideCover: {
      type: Boolean,
      required: false,
      default: false
    },
    interval: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return parseInt(route?.query?.interval) || 5000
      }
    },
    pageMode: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query?.mode === 'page'
      }
    },
    moviesPerPage: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && parseInt(route.query['movies-per-page'])) || 4
      }
    },
    hidePast: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['hide-past'] === 'true'
      }
    },
    showingsHidePoster: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['showings-hide-poster'] === 'true'
      }
    },
    displayShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['display-showing-badges'] === 'true') || false
      }
    }
  },
  data () {
    return {
      errorOccurred: false
    }
  },
  computed: {
    movies () {
      if (!this.site) return

      return _(this.site.todaysShowings.data)
        .filter(showing => !this.hidePast || !showing.past)
        .groupBy('movie.id')
        .sortBy(showings => -showings.length) // Second priority is number of showings
        .sortBy(showings => showings[0].screen.displayOrder) // First priority is what screen it is in
        .value()
    },
    maxShowings () {
      if (!this.site || !this.site.todaysShowings) return 0

      return _(this.movies).values().map('length').max()
    },
    cover () {
      return this.overrideCover || this.$route.query.cover || false
    },
    siteId () {
      return this.overrideSiteId || this.$route.params?.siteId
    },

    hasMultiSlides () {
      return this.movies.length > this.moviesPerPage
    },
    windowHeight () {
      return window.innerHeight
    },
    autoplay () {
      return { delay: this.interval }
    }
  },
  configuration: ['currentSite'],

  async mounted () {
    this.moviesIntervalId = setInterval(() => {
      this.site.fetch(true)
    }, 10 * 60 * 1000)

    await this.site.fetch()

    if (this.$signage) {
      // Fetching the site when in the app mode of digital-signage, sets the site_id cookie
      // This will reload the configuration data after being authenticated
      this.$handleAuthChange()
    }
  },
  beforeUnmount () {
    if (this.timeIntervalId) clearInterval(this.timeIntervalId)

    if (this.moviesIntervalId) clearInterval(this.moviesIntervalId)
  },
  methods: {
    styleForShowing (showing) {
      const style = []
      if (this.$isLandscapeView()) {
        style.push('font-size: 1.5vw')
      } else {
        style.push('font-size: 1.7vh')
      }
      if (showing.past) {
        style.push('text-decoration: line-through; ' + 'color: ' + this.$lightenColor(this.site.primaryColor, 20) + '; border: 0.1vw solid ' + this.$lightenColor(this.site.primaryColor, 20))
      } else if (showing.current) {
        style.push('border: 0.1vw solid #ffffff; color: ' + this.site.primaryColor)
      } else {
        style.push('border: 0.1vw solid #ffffff')
      }
      return style.join(';')
    }
  }
}
</script>

<style scoped>
.site {
  background-color: #161616;
  color: #fff;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.site.debug {
  border: solid 1px red;
}

.site-logo {
  max-width: 20vh;
  max-height: 5vh;
}
.movie-container{
  display: flex;
}

.movie-container:nth-child(odd) {
  background-color: #191919;
}
.debug .movie-container > div {
  border: solid 1px red;
}

.debug .showing {
  border: solid 1px yellow;
}
.past {
  color: #333;
}
.current {
  color: #1e57ff;
}

.background-pattern {
  background-color: #000000;
  opacity: 1;
  background-size: 1vw 1vw;
  background-image: repeating-linear-gradient(45deg, #363636 0, #363636 1px, #000000 0, #000000 50%);
}
</style>
